import React from "react";
import "./styles/UnexpectedErrorPage.css";

const UnexpectedErrorPage: React.FC = () => {
  return (
    <div className="error-page-container">
      <div className="error-page-card">
        <h1 className="error-page-title">😵 Oops, something broke.</h1>
        <p className="error-page-message">
          An unexpected error occurred. Don’t worry — our system is safe.
        </p>
        <p className="error-page-tip">
          Try refreshing the page or contact support if the problem persists.
        </p>
        <button className="error-page-button" onClick={() => window.location.reload()}>
          🔄 Refresh Page
        </button>
      </div>
    </div>
  );
};

export default UnexpectedErrorPage;
